module.exports = __webpack_public_path__ + "static/media/light.68586313.ttf";